var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.classes,style:(_vm.style),attrs:{"data-components":"LeftnaviDotSvg","xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 22 22"}},[_c('circle',{attrs:{"cx":"11","cy":"11","r":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }